import { updateLinksAttributes } from '../../utils/handleAttributes';
import { missingWidget } from '../../utils/helpers';

export default function socialPictures() {
  const widgetName = 'socialPictures';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof socialPicturesOpts === 'undefined' ? null : socialPicturesOpts;

  if (!widgetOpts) {
    $('.social-section').remove();
    missingWidget(widgetName);
    return;
  }

  const wrapContainerClass = 'social-pictures-wrapper';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return new Promise((resolve) => {
    return saffire.widgets.cardWidget($($widget), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      link: ['all'],
      hasImages: true,
      lazyLoadImages: true,
      imageIsBackground: true,
      textOverImage: true,
      maxItemsVisible: 5,
      itemsPerPanel: 1,
      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createCustomCards(data.items);
          resolve(true);
        } else {
          $(`.${wrapContainerClass}`).remove();
          resolve(false);
        }
      },
    });
  });

  function createCustomCards(widgetData) {
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const $cardItem = $(this);
      const { URL, Title } = widgetData[x];

      $cardItem.find('.image-container').wrap('<div class="img-wrapper"></div>');

      updateLinksAttributes(URL, Title, $cardItem);
    });
  }
}
